module.exports = __webpack_public_path__ + "assets/img/game-btn.f2f2b00f.png";